// @flow
import * as React from 'react';
import { pubDir } from './../../config';
import { useAppDispatch } from '../../hooks';
import { useSelector } from 'react-redux';
import { signOut } from '../../Store/appSlicer';
import { IAuthResponse, UserRoles } from '../../Interfaces';
import { AppBar, Avatar, Box, Container, IconButton, ListItem, Menu, MenuItem, Toolbar, Tooltip, Typography } from '@mui/material';
import { NavLink, useNavigate } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import { RoleTransate } from '../../Helpers/Translations';


type Link = {
  url: string,
  title: string
}
export function Header():React.JSX.Element {
  const dispatch = useAppDispatch()
  const navigate = useNavigate();
  const bearerToken:IAuthResponse  = useSelector( (state:IAuthResponse) => state)
  const [pages, setPages] = React.useState<Link[]>([])
  const adminPages:Link[] = [
    { url: '/', title: 'Standorte'},
    { url: '/locations/f/', title: 'Freiplatzmeldungen'},
    { url: '/history', title: 'Meldungshistorie'},
    { url: '/usermanager', title: 'Nutzerverwaltung'},
    ];

  const userPages:Link[] = [
    { url: '/', title: 'Freiplatzmeldungen'},
    { url: '/history', title: 'Meldungshistorie'},
    ];

  React.useEffect( () => {


      if (RoleTransate(bearerToken.role) === UserRoles[0].roleTitle) setPages(adminPages)
      if (RoleTransate(bearerToken.role) ===  UserRoles[1].roleTitle) setPages(userPages)
  }, [bearerToken])


    const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
    const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);

    const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
      setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
      setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
      setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
      setAnchorElUser(null);
    };


  return (
<AppBar position="static" >
      <Container maxWidth={false} className='siteHeader'  >
        <Toolbar disableGutters>
          <Typography

            variant="h6"
            noWrap
            component="a"
            //href="#app-bar-with-responsive-menu"
            href="/"
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
<div >
        <img src={`${pubDir}img/logo_FundW_small.svg`} width="140"  className="siteFooter__logo" alt="Fördern und Wohnen"></img>
        <div className='white' style={{ marginTop: '-20px'}}>Freiplatzmeldung</div></div></Typography>

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              {
                (pages.length !== 0) && <MenuIcon />
              }

            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >

              {pages.map((page) => (
                <MenuItem key={page.title} onClick={() => {
                  navigate(page.url);
                  handleCloseNavMenu();
                }} >{page.title}
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <Typography
            variant="h5"
            noWrap
            component="a"
            href="#app-bar-with-responsive-menu"
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            {/* <NavLink to='/'><img src={`${pubDir}img/logo_FundW_small.svg`} width="140"  className="siteFooter__logo" alt="Fördern und Wohnen"></img></NavLink> */}

        <label className='white' style={{fontSize: '18px', letterSpacing: 0.1}}>F&W Freiplatzmeldung</label>
          </Typography>
          {/* Horisontal menu */}

            <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            <nav className='nav'>
              <ul>
              {pages.map((page) => (
                  <li key={`hm${page.title}`}>
                  <NavLink color="inherit" to={page.url}
                  style={({ isActive }) => {
                    return {
                      fontWeight: isActive ? "bold" : "",
                    };
                  }}>{page.title}</NavLink></li>
              ))}
              </ul></nav>
            </Box>
          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar alt={bearerToken.username}/>
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
                {
            bearerToken.isLoggedIn && [
              <ListItem key="name">Name: {bearerToken.fullname}</ListItem>,
              <ListItem key="konto">Konto: {bearerToken.username}</ListItem>,
              <ListItem key="role">Rolle: {RoleTransate(bearerToken.role)}</ListItem>,
              <MenuItem key="logout" onClick={() => {
                handleCloseUserMenu();
                dispatch(signOut());
                navigate('/');
              }}>
                Abmelden
              </MenuItem>
            ]
          }
          {
            !bearerToken.isLoggedIn &&
            <MenuItem onClick={() => {
              handleCloseUserMenu();
              navigate('/');
            }}>
              Anmelden
            </MenuItem>
            }



            </Menu>

          </Box>
        </Toolbar>
      </Container>
    </AppBar>



  );
};